/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * The type of entry representing whether the transaction resulted in a credit to or debit from the card account balance.
A `DEBIT` transaction indicates a positive value added to the account (e.g. points reward, refund), while a `CREDIT` transaction indicates a negative value subtracted from the account balance (e.g. purchase, interest charge).

 */
export type CardAccountTransactionEntryType = typeof CardAccountTransactionEntryType[keyof typeof CardAccountTransactionEntryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAccountTransactionEntryType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
} as const;
